import { getLang } from '@/helpers/getLang'
import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type AnimalType = {
    id: number
    title: string,
    value: string,
    image: string,
    tags: number[],
    icon: string,
    animal_types_category?: any
}

export type AnimalTypeDto = {
    title: string,
    value: string,
    image: string,
    tags: number[],
    icon: string
}

export const animalTypesApi = createApi({
    reducerPath: 'animalTypesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["ANIMAL-TYPE"],
    endpoints: builder => ({
        getAllAnimalTypes: builder.query<AnimalType[], void>({
            query: () => ({ url: `/animal-types?lang=${getLang()}` }),
            providesTags: ["ANIMAL-TYPE"]
        }),
        getAllAnimalTypesEn: builder.query<AnimalType[], void>({
            query: () => ({ url: `/animal-types?lang=en` }),
            providesTags: ["ANIMAL-TYPE"]
        }),
        getAnimalType: builder.query<AnimalType, { id: number }>({
            query: ({ id }) => ({ url: `/animal-types/${id}` }),
            providesTags: ["ANIMAL-TYPE"]
        }),
        createAnimalType: builder.mutation<any, AnimalTypeDto>({
            query: (data) => ({url: `/animal-types`, method: "POST", body: data}),
            invalidatesTags: ["ANIMAL-TYPE"]
        }),
        deleteAnimalTypesByIds: builder.mutation<any, any>({
            query: (data)=> ({url: `/animal-types/delete-by-ids/del`, method: "POST", body: data}),
            invalidatesTags: ["ANIMAL-TYPE"]
        }),
        updateAnimalTypes: builder.mutation<any, any>({
            query: data => ({ url: `/animal-types/${data.id}`, method: 'PATCH', body: data }),
            invalidatesTags: ["ANIMAL-TYPE"]
        }),
        updateAnimalTypesEn: builder.mutation<any, any>({
            query: data => ({ url: `/animal-types/en/update/${data.id}`, method: 'PATCH', body: {title: data.title, value: data.value} }),
            invalidatesTags: ["ANIMAL-TYPE"]
        }),
    })
})

export const { useGetAllAnimalTypesQuery, useUpdateAnimalTypesEnMutation, useGetAllAnimalTypesEnQuery, useGetAnimalTypeQuery, useCreateAnimalTypeMutation, useDeleteAnimalTypesByIdsMutation, useUpdateAnimalTypesMutation } = animalTypesApi
